export enum EmailTemplateEnum {
  "d-c665091bd803443bb91db7ae3e75dd6d" = "MFA Email",
  "d-13a3e726d8eb4a11a9d53892440b1f13" = "Forgot Password Email",
  "d-e963ded82ba748228d571deb70245948" = "CFET New Practitioner Colleague List Request",
  "d-d8378cb7cffc4ff592f6f982216f69ed" = "CFET Existing Practitioner Colleague List Request",
  "d-3f0472a8a0074b3eabcbe7d7040a3a98" = "CFET Registration Confirmation",
  "d-0d6c1fd3235841c683caa4e0a954cae1" = "CFET Forgot Password",
  "d-305069c1bd9a4d31b6d4cb4bcc39074f" = "CFET Colleague Feedback Request",
  "d-d80552cd31814473ba41e511ffe514d3" = "PAIS Practice Minimum Responses Reached",
  "d-b0ed23e035294a48b930c25850011d57" = "PAIS Practice With Practitioners Minimum Responses Reached",
  "d-35842b36d53f4a14bc4c36f89778d2b1" = "MSF Minimum Responses Reached",
  "d-deb5ecd88b244019855cbb5c9c069b09" = "MSF Minimum Responses Percentage Reached",
  "d-09dc48f5587b40fa8d637bc85e207358" = "PAIS Is Practice Only Minimum Responses Percentage Reached",
  "d-6ace5877375f4c2da1f30751ad0ab858" = "PAIS Practice With Practitioners Minimum Responses Percentage Reached",
  "d-b01e19a6d161413f9261c8cfd32b1878" = "MSF Practitioner Minimum Paper Responses Not Met",
  "d-2ed4933ce13a48f0b3537a7b8915d6af" = "PAIS Practitioner Minimum Paper Responses Not Met",
  "d-816f728bf1374b25992f099bf08c0c04" = "PAIS Practice Minimum Paper Responses Not Met",
  "d-bce2d53d00b44b2f9fba9332b0858f5d" = "SA Questionnaire Email",
  "d-193c83f9bc7d4e7fbb7ba0ee352da441" = "RACP SA Questionnaire Email",
  "d-7a01a624982f4654ab1e4cec7c129719" = "New User Welcome Email",
  "d-c4a26af33b074f26a186df7220363e14" = "Existing User Survey Assigned Email",
  "d-17285da4a8a2406896e48dab35f2a5b1" = "Practitioner Report Available",
  "d-54dde9b979504831bb719f134034e7dd" = "Impersonation Started",
}
